<template>
  <my-view :LoginCheckByCode="LoginCheckByCode" :LoginCheckBySign="LoginCheckBySign"></my-view>
</template>

<script>
import {
  LoginCheckByCode,
  LoginCheckBySign,
} from "@/pages/page1/api/modules/login";

import MyView from "@/pages/publicView/login/wxLogin_view.vue";

export default {
  components: { MyView },
  data() {
    return {
      LoginCheckByCode,
      LoginCheckBySign,
    };
  },
};
</script>